import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';

import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import EventIcon from '@material-ui/icons/Event';
import DoneIcon from '@material-ui/icons/Done';
import MapIcon from '@material-ui/icons/Map';
import BuildIcon from '@material-ui/icons/Build';
import ClearIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';

import {CopyToClipboard} from 'react-copy-to-clipboard';

import noimage from '../../assets/images/noimage.jpg'

import 'moment/locale/fr';
moment.locale('fr');

const styles = theme => ({
  card: {
    width: "100%",
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
  actionArea: {
    width: '100%'
  },
  actions: {
    display: 'block',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
    [theme.breakpoints.up('sm')]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
    [theme.breakpoints.up('lg')]: {
        display: "none",
    },
  },
  link: {
    textDecoration: 'none'
  },
  linkIcon: {
    textDecoration: 'none',
    height: 24,
    color: "#000000",
  }
});

class AuditCard extends React.Component {
  state = {
    expanded: false,
    copied: false,
  };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  render() {
    const { classes, displaySnackbar, closeSnackbar } = this.props;

    return (
      <Card className={classes.card} >
        <CardHeader
            avatar={
              <Avatar aria-label="Recipe" className={classes.avatar}>
                {this.props.audit.company.name.charAt(0).toUpperCase()}
              </Avatar>
            }
            title={this.props.audit.company.name.charAt(0).toUpperCase() + this.props.audit.company.name.slice(1)}
            subheader={this.props.audit.date ? moment(this.props.audit.date).format("DD/MM/YY à HH:mm") : ""}
          />
          <Link to={"/audits/" + this.props.audit.id} className={classes.link}>
            <CardMedia
              className={classes.media}
              image={(this.props.audit.preview && "path" in this.props.audit.preview) ? this.props.audit.preview.path : noimage}
              title="Lieu de l'audit"
            />
          </Link>
          <CardContent>


            <CopyToClipboard text={this.props.audit.address}
                             onCopy={() => this.setState({copied: true}, () => {
                               displaySnackbar("success", "Copié", true);
                               setTimeout(closeSnackbar, 3000)
                             })}>
              <span>
                <Typography component="p">
                  Adresse : {this.props.audit.address}
                </Typography>
              </span>
            </CopyToClipboard>

          </CardContent>
        <CardActions className={classes.actions} disableActionSpacing>


          {(() => {
            switch(this.props.audit.status) {
              case 'waiting':
                return <Tooltip title="En attente"><HourglassEmptyIcon /></Tooltip>;
              case 'appointment':
                return <Tooltip title="Rendez-vous validé"><EventIcon /></Tooltip>;
              case 'appointment_notified':
                  return <Tooltip title="Rendez-vous non validé"><CalendarTodayIcon /></Tooltip>;
              case 'valid':
                return <Tooltip title="Validé"><DoneIcon /></Tooltip>;
              case 'issue':
                return <Tooltip title="Écart"><BuildIcon /></Tooltip>;
              case 'reject':
                return <Tooltip title="Rejeté"><ClearIcon /></Tooltip>;
              default:
                return null;
            }
          })()}

          <Tooltip title="Ouvrir dans Google maps">
            <a href={"https://maps.google.com/?q=" + this.props.audit.address} style={{"float": "right"}} className={classes.linkIcon} target='_blank'>
              <MapIcon />
            </a>
          </Tooltip>
        </CardActions>
      </Card>
    );
  }
}

AuditCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuditCard);



// WEBPACK FOOTER //
// ./src/component/utils/AuditCard.js